import React from 'react';
import { Tag } from 'antd';

import { MonitoringSchedule, MonitoringWindowType } from '@sonar-software/sonar-core';

const notificationFrequencyColors: Record<MonitoringWindowType | MonitoringSchedule, string> = {
	[ MonitoringWindowType.Hourly ]: 'orange',
	[ MonitoringWindowType.Weekly ]: 'green',
	[ MonitoringWindowType.Monthly ]: 'purple',
	[ MonitoringWindowType.Daily ]: 'cyan',
	[ MonitoringSchedule.Immediately ]: 'volcano'
};

export interface NotificationFrequencyTagProps {
	frequency: MonitoringWindowType | MonitoringSchedule | undefined;
}

export const NotificationFrequencyTag: React.FC<NotificationFrequencyTagProps> = ({ frequency }) => {
	if (!frequency) {
		return null;
	}

	const label = MonitoringWindowType[ frequency as MonitoringWindowType ] ??
		MonitoringSchedule[ frequency as MonitoringSchedule ];

	const color = notificationFrequencyColors[ frequency ];

	return <Tag color={ color }>{ label }</Tag>;
};
